import { render, staticRenderFns } from "./ProductEditPriceRules.vue?vue&type=template&id=4b48132c"
import script from "./ProductEditPriceRules.vue?vue&type=script&lang=ts"
export * from "./ProductEditPriceRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b48132c')) {
      api.createRecord('4b48132c', component.options)
    } else {
      api.reload('4b48132c', component.options)
    }
    module.hot.accept("./ProductEditPriceRules.vue?vue&type=template&id=4b48132c", function () {
      api.rerender('4b48132c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/products/ProductEditPriceRules.vue"
export default component.exports